import React from 'react';
import classnames from 'classnames';
import styles from './delete-button.css';
import { DeleteIcon } from '../icons/icons';
import { Icon } from '../icon';

interface DeleteButtonProps {
  /** Adds additional classes to the component. */
  className?: string;
  /** Button Type */
  type?: 'submit' | 'reset' | 'button';
  /** Provides visual elements that communicates that the button is disabled. Disallows user interaction */
  disabled?: boolean;
  /** Callback when clicked. */
  onClick?: () => void;
  /** The content to display inside the button */
  children: React.ReactNode;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * A Button with a Delete Icon
 *
 * @param {DeleteButtonProps} props
 *
 * @returns JSX.ELEMENT
 */
const DeleteButton = ({
  className,
  children,
  'data-testid': dataTestId,
  type = 'button',
  disabled = false,
  onClick
}: DeleteButtonProps) => {
  const deleteButtonClass = classnames(styles.deleteButton, className);
  const ICON_SIZE = '15px';

  return (
    <button
      className={deleteButtonClass}
      type={type}
      disabled={disabled}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <Icon className={styles.icon} size={ICON_SIZE}>
        <DeleteIcon />
      </Icon>
      {children}
      {disabled ? <div className={styles.chromeHackForDisabledButtonMouseEvents} /> : null}
    </button>
  );
};

export default DeleteButton;
